import PageContainer from "./PageContainer.ts";

export { paddingXCss, paddingYCss } from "./PageContainer.ts";

export default PageContainer;
